import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
import { CdnIcon } from '@shared/ui';
import SeatPrice from '../../SeatPrice/SeatPrice';
import { Money as MoneyType } from '../../../../types';

interface Props {
	className?: string;
	title?: string;
	description?: string;
	price?: MoneyType;
}

const ChangeSeat: React.FC<Props> = ({ className, title: titleProp, description: descriptionProp, price }) => {
	const { ChangeSeat: css } = useTheme('SeatMap');
	const { t } = useTranslation('SeatMap');

	const title = titleProp || t('Change seat');
	const description =
		descriptionProp || t('Charged when selecting any location instead of the designated one for free.');

	return (
		<div className={cn(css.root, className)}>
			<div className={css.header}>
				<CdnIcon className={css.icon} icon="Services/Change seat" />

				<div className={css.content}>
					<div className={css.title}>{title}</div>
					<div className={css.description}>{description}</div>
				</div>
			</div>

			{!!price && (
				<>
					<div className={css.line} />

					<div className={css.footer}>
						<SeatPrice
							className={css.seatPrice}
							moneyClassName={css.price}
							money={price}
							priceFrom={true}
						/>
					</div>
				</>
			)}
		</div>
	);
};

export default ChangeSeat;
